export default __webpack_public_path__ + "static/media/Ostali 8.d4c7f6ff.jpg";